<template>
  <!-- <div class="main-container"> -->
  <div class="main-container box-page">
    <HeaderDefault />
    <!-- Navbar section -->
    <div class="site-wrapper-box">
      <div class="site-wrapper">
        <!-- hero section -->
        <HeroEbook />

        <TeamAgency />

        <!-- <EbookIntro /> -->

        <Version2Features />
        <!-- hero section -->

        <!-- pitch video -->
        <!-- <PitchVideo /> -->

        <!-- clinic feature section -->
        <!-- <ClinicFeatureSection /> -->

        <!-- clinic work step section -->
        <ClinicWorkStep />

        <InstructionVideo />
        <!-- pricing section -->

        <ClinicPricing />

        <!-- <PitchDeck /> -->

        <!-- newsletter section -->
        <HeroClinic />

        <div class="pt-5 mt-5"></div>
        <Newsletter />

        <!-- footer section -->
        <FooterMain />
      </div>
    </div>
  </div>
</template>

<script>
import TeamAgency from "@/components/sections/TeamAgency";
// import EbookIntro from "@/components/sections/EbookIntro";
import HeaderDefault from "@/components/sections/HeaderDefault";
import HeroClinic from "@/components/sections/HeroClinic";
import HeroEbook from "@/components/HeroEbook";
// import ClinicFeatureSection from "@/components/sections/ClinicFeatureSection";
import ClinicWorkStep from "@/components/sections/ClinicWorkStep";
import ClinicPricing from "@/components/sections/ClinicPricing";
import Newsletter from "@/components/Newsletter";
import FooterMain from "@/components/FooterMain";
// import PitchVideo from "@/components/sections/PitchVideo.vue";
// import PitchDeck from "@/components/sections/PitchDeck.vue";
import Version2Features from "@/components/sections/Version2Features.vue";
import InstructionVideo from "@/components/sections/InstructionVideo.vue";

export default {
  name: "app",
  components: {
    // EbookIntro,
    TeamAgency,
    HeroEbook,
    HeaderDefault,
    HeroClinic,
    // ClinicFeatureSection,
    ClinicWorkStep,
    ClinicPricing,
    Newsletter,
    FooterMain,
    // PitchVideo,
    // PitchDeck,
    Version2Features,
    InstructionVideo,
  },
  metaInfo: {
    title: "Sandrasoft",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  created() {
    this.scrollToTop();
  },
};
</script>

<style lang="scss">
@import "../assets/scss/_variabls.scss";
@import "../assets/scss/page-section/_clinic.scss";
</style>
